<mat-form-field class="me-3">
  <mat-label>Application</mat-label>
  <mat-select
    name="apps"
    [(ngModel)]="selectedApp"
    (selectionChange)="onAppChange()"
  >
    @for (app of applications; track app.value) {
      <mat-option [value]="app.value">
        {{ app.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
<mat-form-field class="me-3">
  <input
    type="text"
    placeholder="Search For a Unit"
    matInput
    name="unitsControl"
    [matAutocomplete]="auto"
    [formControl]="unitsControl"
    [(ngModel)]="selectedUnit"
    (blur)="checkSelection()"
  />
  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="autoCompleteUnitChanged($event)"
  >
    @for (unit of filteredUnits; track unit.id) {
      <mat-option [value]="unit.id">
        {{ unit.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
<mat-form-field class="me-3">
  <mat-label>Pick a ReportType</mat-label>
  <mat-select name="reportTypes" [(ngModel)]="selectedType">
    @for (type of reportTypes; track type) {
      <mat-option [value]="type">
        {{ type }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
<button
  type="button"
  mat-raised-button
  color="accent"
  [disabled]="(!selectedApp && !selectedType) || !selectedUnit"
  (click)="getUnitProfileReport()"
>
  Get Unit Settings Report
</button>
<ngx-loading [show]="loading" />
